import React from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { Fab, Action } from 'react-tiny-fab'
import 'react-tiny-fab/dist/styles.css'
import AddIcon from '@material-ui/icons/Add'
import CloudUploadIcon from '@material-ui/icons/CloudUpload'
import PersonAddIcon from '@material-ui/icons/PersonAdd'
import PublishIcon from '@material-ui/icons/Publish'

const MAIN_BUTTON_STYLES = { backgroundColor: '#1976D2' }

/**
 * Actions rapides contextuelles — une config par page utile.
 * Masqué partout ailleurs (pages avec CTA déjà présent ou sans action pertinente).
 */
const getFabActions = (pathname) => {
  if (pathname === '/corporate/dashboard') {
    return [
      { text: 'Nouvel envoi PDF', icon: <CloudUploadIcon />, to: '/corporate/import' },
      { text: 'Nouveau client', icon: <PersonAddIcon />, to: '/corporate/clients?new=1' },
    ]
  }

  if (pathname === '/dashboard') {
    return [
      { text: 'Import mensuel', icon: <PublishIcon />, to: '/import' },
    ]
  }

  return null
}

const FabButton = () => {
  const location = useLocation()
  const history = useHistory()
  const actions = getFabActions(location.pathname)

  if (!actions?.length) return null

  return (
    <Fab
      mainButtonStyles={MAIN_BUTTON_STYLES}
      icon={<AddIcon />}
      alwaysShowTitle
    >
      {actions.map((action) => (
        <Action
          key={action.text}
          text={action.text}
          onClick={() => history.push(action.to)}
        >
          {action.icon}
        </Action>
      ))}
    </Fab>
  )
}

export default FabButton
